import { Box } from '@material-ui/core';
import Text from 'components/Text';
import styled from 'hooks/styled';

const Wrapper = styled(Box)(({ theme, status }) => ({
  padding: '6px 24px',
  borderRadius: '8px',
  boxShadow: '0px 0px 8px 0px rgba(45, 53, 67, 0.12)',
  width: 'fit-content',
  background:
    status === 'discontinued'
      ? theme.palette.colors.orange
      : theme.palette.secondary.red,
}));

const ProductStatus = ({ status, ...rest }) => {
  return (
    <Wrapper status={status} {...rest}>
      <Text variant="label2" uppercase color="#fff">
        {status === 'discontinued' ? 'Discontinued' : 'Deleted'}
      </Text>
    </Wrapper>
  );
};

export default ProductStatus;
